module.exports = __webpack_public_path__ + "img/4972.a0418549.jpg";